export const issuePriorityNodes = view => [
  view.state.schema.nodes.form_label.create({id: 'priority'}, view.state.schema.text('Priority')),
  view.state.schema.nodes.form_select.create({
    id: 'priority',
    name: 'priority',
    settings: {
      values: [
        {
          "name": "Lowest",
          "value": "Lowest",
          "icon": "angle double down blue"
        },
        {
          "name": "Low",
          "value": "Low",
          "icon": "angle down blue"
        },
        {
          "name": "Medium",
          "value": "Medium",
          "icon": "minus yellow",
          "selected": true
        },
        {
          "name": "High",
          "value": "High",
          "icon": "angle up orange"
        },
        {
          "name": "Highest",
          "value": "Highest",
          "icon": "angle double up orange"
        },
        {
          "name": "Blocker",
          "value": "Blocker",
          "icon": "exclamation circle red"
        }
      ]
    },
  })
];